import React from 'react';

interface ClearFiltersProps {
    isActive: boolean;
    clearAllFilters: () => void;
  }

const ClearFilters: React.FC<ClearFiltersProps> = ({isActive, clearAllFilters}) => {
  return (
    <div className='mjp_section-wrapper m-t-16 clear-filters-wrapper' onClick={() => clearAllFilters()}>
        <button disabled={!isActive} className='clear-filters-btn'>Clear search/filter & view all jobs</button>
    </div>
  )
}

export default ClearFilters;